import { FC } from 'react';
import { Provider } from 'react-redux';
import { createReduxWrapper } from '@doda/common/src/redux/utils/createReduxWrapper';
import { HEADER_NAV_MENU } from '@doda/pc/src/constants/headerNavMenu';
import { BasicLayout } from '@doda/pc/src/components/layouts/BasicLayout';
import { PageViewAnalytics } from '@doda/common/src/components/JobContent/PageViewAnalytics';
import {
  PAGE_NAME_PC,
  CHANNEL,
} from '@doda/common/src/constants/seo/jobTrendConstants';
import { JobTrendScreenProps, JobTrendScreen } from './screens/JobTrendScreen';
import { reducer } from './redux/store';
import { initServerSideProps } from './initServerSideProps';

/**
 * JobTrendPageページのProps
 */
export interface JobTrendPageProps {
  pageProps: JobTrendScreenProps;
}

const JobTrend: FC<JobTrendPageProps> = (pageProps) => {
  const { store, props } = wrapper.useWrappedStore(pageProps);
  const { targetName, isLogin, breadcrumbData, isJobRankingLinkShow } =
    props.pageProps;

  return (
    <Provider store={store}>
      <BasicLayout
        selectedNavItem={HEADER_NAV_MENU.SEARCH}
        leadSentence={`${targetName} doda掲載中求人の傾向`}
      >
        <PageViewAnalytics pageName={PAGE_NAME_PC} channel={CHANNEL} />
        <JobTrendScreen
          targetName={targetName}
          isLogin={isLogin}
          breadcrumbData={breadcrumbData}
          isJobRankingLinkShow={isJobRankingLinkShow}
        />
      </BasicLayout>
    </Provider>
  );
};

const wrapper = createReduxWrapper(reducer);

export const getServerSideProps =
  wrapper.getServerSideProps(initServerSideProps);

export default JobTrend;
